<script setup lang="ts">
import ExperienceBaseHeader from "@/components/ExperiencePage/Header/ExperienceBaseHeader.vue";
import type { LayoutProps } from "./types";

const props = withDefaults(defineProps<LayoutProps>(), {
  ldClient: "",
  logoUrl: "",
  logoUrlSquare: "",
});
</script>

<template>
  <experience-base-header :ld-client="props.ldClient" :logo="props.logoUrlSquare" />
  <div class="w-full mx-auto h-full md:flex md:flex-col">
    <main>
      <slot />
    </main>
  </div>
</template>

